/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
////import React, { useState } from 'react';
import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component
import { useParams } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import api from "../../../services/api";
import qs from "qs";
import { useLocation } from 'react-router-dom';
import { Container, Row, Col } from "reactstrap";
import { ConfirmDeleteAlert, DeleteFailedAlert, DeleteSuccessAlert } from "../../alerts";
import { TooltipButton } from '../../inputs';
import fileDownload from "js-file-download";
import Loader from "../../loaders";
import RateImportDialog from './RateImportDialog';
import { ParagraphNotification } from '../../alerts';
import { DateComparator, DateValueFormatter, CurrencyValueFormatter } from '../../../helpers/AgGridHelper';
import { Mode } from "../../../utils";
import RatesEditor from "./RateEditor";
import { requiresRoles } from '../../Can';
import { roles } from '../../../auth/roles';

const timeoutLength = 1500;
const apiurl = "rates";

export default function RateGrid(props) {
    const {
        selectedProject,
        setTopLeftBar
    } = props;

    const location = useLocation();
    const {
        projectid,
    } = qs.parse(location.search, { ignoreQueryPrefix: true });

    const { instance } = useMsal();
    const user = instance.getActiveAccount();

    const params = useParams();
    const [data, setData] = React.useState([]);
    const [attrCols, setAttrCols] = React.useState([]);
    const [drawerMode, setDrawerMode] = React.useState(Mode.NONE);
    const [copiedIndex, setCopiedIndex] = React.useState(null);
    const [loading, setLoading] = React.useState(false);
    const [itemInEdit, setItemInEdit] = React.useState(null);
    const [canAutoOpen, setCanAutoOpen] = React.useState(true);
    const [pageNumber, setPageNumber] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(50);
    const [deleteAlert, setDeleteAlert] = React.useState([]);
    const [lookups, setLookups] = React.useState({ components: [], employmentcategories: [] });
    const [pnMessage, setPnMessage] = React.useState(null);
    const [pnTitle, setPnTitle] = React.useState(null);
    const [paragraphNotification, setParagraphNotification] = React.useState([]);
    const [pnTitleOnGenerate, setPnTitleOnGenerate] = React.useState(``);
    const [importDialogIsOpen, setImportDialogIsOpen] = useState(false);
    const [isReadonly, setIsReadonly] = useState(true);
    const skipPageResetRef = React.useRef();
    const gridRef = useRef();

    useEffect(() => {
        requiresRoles([roles.Admin, roles.HR], user, () => {
            setIsReadonly(false);
        });
    }, [user]);

    React.useEffect(() => {
        if (copiedIndex !== null) {
            const timeoutId = setTimeout(() => {
                setCopiedIndex(null);
            }, timeoutLength);

            return () => clearTimeout(timeoutId);
        }
    }, [copiedIndex]);

    const defaultColumns1 = [
        {
            title: "Category",
            name: "employmentCategory.lookupValue",
            rowGroup: true,
            hide: true,
            minWidth: 150,
            width: 150,
        },
        {
            title: "Location",
            name: "location.locationName",
            minWidth: 150,
            width: 150,
        },
        {
            title: "Position",
            name: "position.positionName",
            minWidth: 150,
            width: 150,
        },
        {
            title: "Roster Sequence",
            name: "rosterSequence.label",
            minWidth: 150,
            width: 150,
        },
        {
            title: "Start Date",
            name: "startDate",
            field: 'date',
            filter: 'agDateColumnFilter',
            valueFormatter: DateValueFormatter,
            filterParams: {
                comparator: DateComparator
            },
            minWidth: 100,
            width: 100,
        },
        {
            title: "End Date",
            name: "endDate",
            field: 'date',
            filter: 'agDateColumnFilter',
            valueFormatter: DateValueFormatter,
            filterParams: {
                comparator: DateComparator
            },
            minWidth: 100,
            width: 100,
        },
        {
            title: "Fulltime Rate",
            name: "fulltimeRate",
            valueFormatter: CurrencyValueFormatter,
            minWidth: 100,
            width: 100,
        },
        {
            title: "Full Time Rate DS",
            name: "fullTimeRateDs",
            valueFormatter: CurrencyValueFormatter,
            minWidth: 100,
            width: 100,
        },
        {
            title: "Full Time Rate NS",
            name: "fullTimeRateNs",
            valueFormatter: CurrencyValueFormatter,
            minWidth: 100,
            width: 100,
        },
        {
            title: "Overtime Rate",
            name: "overtimeRate",
            valueFormatter: CurrencyValueFormatter,
            minWidth: 100,
            width: 100,
        },
        {
            title: "Casual Normal Time",
            name: "casualNormalRate",
            valueFormatter: CurrencyValueFormatter,
            minWidth: 100,
            width: 100,
        },
        {
            title: "Casual Nightshift",
            name: "casualNormalNightRate",
            valueFormatter: CurrencyValueFormatter,
            minWidth: 100,
            width: 100,
        },
        {
            title: "Casual Nightshift Weekend Rate",
            name: "casualHolidayNightRate",
            valueFormatter: CurrencyValueFormatter,
            minWidth: 100,
            width: 100,
        },
        {
            title: "Casual NS (if not std%)",
            name: "casualNsnotStandard",
            valueFormatter: CurrencyValueFormatter,
            minWidth: 100,
            width: 100,
        },
        {
            title: "Full Time Offsite Rate",
            name: "fullTimeOffsiteRate",
            valueFormatter: CurrencyValueFormatter,
            minWidth: 100,
            width: 100,
        },
        {
            title: "Casual Offsite Rate",
            name: "casualOffsiteRate",
            valueFormatter: CurrencyValueFormatter,
            minWidth: 100,
            width: 100,
        },
        {
            title: "Full Time Training",
            name: "fullTimeTraining",
            valueFormatter: CurrencyValueFormatter,
            minWidth: 100,
            width: 100,
        },
        {
            title: "Casual Training",
            name: "casualTraining",
            valueFormatter: CurrencyValueFormatter,
            minWidth: 100,
            width: 100,
        },
        {
            title: "Casual Loading Rate",
            name: "casualLoadingRate",
            valueFormatter: CurrencyValueFormatter,
            minWidth: 100,
            width: 100,
        },
        {
            title: "Notes",
            name: "notes",
            minWidth: 150,
            width: 150,
        },
    ];

    const defaultColumns2 = [
        {
            name: "button",
            title: "Action",
            pinned: 'right',
            filter: '',
            //width: 85,
            width: 130,
            filterParams: {
                name: 'action'
            },
            sortable: false,
            floatingFilter: false,
            cellClass: "action-button-cell",
            cellRenderer: (params) => {
                var { data } = params;
                var index = 0;

                if (!data) return null;

                return (
                    <div key={data.rateId} style={{ width: "100%" }} className={`d-flex flex-wrap justify-content-center align-items-center`}>
                        <TooltipButton
                            id={`edit_${data.rateId}`}
                            title={isReadonly ? "View" : "Edit"}
                            className="btn-icon mb-2"
                            color="default"
                            size="xsm"
                            type="button"
                            onClick={(event) => {
                                setItemInEdit(data);
                                setDrawerMode(isReadonly ? Mode.VIEW : Mode.EDIT);
                            }}
                        >
                            <i className={`fas ${isReadonly ? "fa-search" : "fa-pencil-alt"} pt-1`}></i>
                        </TooltipButton>
                    {
                        isReadonly ?
                        null
                        :
                        <TooltipButton
                            id={`delete_${data.rateId}`}
                            title="Delete"
                            className="btn-icon mb-2"
                            color="warning"
                            size="xsm"
                            type="button"
                            onClick={(event) => handleDelete(data)}
                        >
                            <i className="fas fa-trash-alt pt-1"></i>
                        </TooltipButton>
                    }
                    </div>
                )
            }
        },
    ];

    const autoGroupColumnDef = {
        filterValueGetter: params => params.data.employmentCategory?.lookupValue,
        filter: 'agTextColumnFilter',
        filterParams: {
            buttons: ['reset'],
            debounceMs: 200,
            excelMode: 'mac',
        },
        floatingFilter: true,
        floatingFilterComponentParams: {
            suppressFilterButton: true,
        },
        suppressMenu: true,
    };

    const columnDefs = useMemo(() => {
        var defaultCols1 = defaultColumns1.map((c) => {
            var obj = {
                ...c,
                field: c.name,
                headerName: c.title,
            };

            if ('name' in obj) delete obj.name;
            if ('title' in obj) delete obj.title;

            return obj;
        });
        var defaultCols2 = defaultColumns2.map((c) => {
            var obj = {
                ...c,
                field: c.name,
                headerName: c.title,
            };

            if ('name' in obj) delete obj.name;
            if ('title' in obj) delete obj.title;

            return obj;
        });

        var attrNo = 0;

        // If there is custom columns
        if (attrCols && attrCols.length) {
            var attrHeader = attrCols.map(s => {
                attrNo++;
                var { key, name, orderIndex } = s;
                return {
                    field: key,
                    headerName: name,
                    //headerName: `${attrNo}. ${name}`,
                };
            });

            return defaultCols1.concat(attrHeader, defaultCols2);
        }
        else {
            return defaultCols1.concat(defaultCols2);
        }
    }, [attrCols, isReadonly]);

    const defaultColDef = useMemo(() => ({
        sortable: true,
        resizable: true,
        //filter: true,
        editable: false,
        //filter: 'agSetColumnFilter',
        filter: 'agTextColumnFilter',
        filterParams: {
            buttons: ['reset'],
            debounceMs: 200,
            excelMode: 'mac',
        },
        floatingFilter: true,
        floatingFilterComponentParams: {
            suppressFilterButton: true,
        },
        suppressMenu: true,
    }), []);

    const loadingOverlayComponent = useMemo(() => Loader, []);

    const onCellEditRequest = useCallback((event) => {
        // console.log("on cell edit request: ", { event });
    }, []);

    const updateSingleRow = useCallback((id) => {
        var gridApi = gridRef.current.api;
        gridApi.forEachNode(rowNode => {
            if (id == rowNode.data.messageLogId) {
                const url = `/${apiurl}/${id}`;
                setLoading(true);

                api.get(url)
                    .then(({ data }) => {
                        //console.log('data to set', 'data', data);
                        rowNode.setData(data)
                    })
                    .catch((error) => {
                        console.error("error: ", { error });
                    })
                    .finally(() => setLoading(false))
                ;
            }
        });
    }, [gridRef]);

    const loadData = React.useCallback((paramObject = null) => {
        const queryString = qs.stringify(paramObject, { allowDots: false });
        skipPageResetRef.current = true;
        setItemInEdit(null);
        setData([]);

        setDrawerMode(Mode.NONE);

        if (!selectedProject) {
            return
        }

        const url = `/${apiurl}/${selectedProject.projectId}?${queryString}`;
        setLoading(true);

        api.get(url)
            .then(({ data }) => {
                var newData = [...data];
                setData(newData);
            })
            .catch((error) => {
                setItemInEdit(null);
                setData([]);
                setAttrCols([]);
                console.error("error: ", { error });
            })
            .finally(() => setLoading(false))
        ;
    }, [pageNumber, pageSize, params, selectedProject]);

    const handleDelete = React.useCallback((item) => {
        const success = (response) => {
            if (!response.status === 200) {
                throw new Error("Delete failed.");
            }
            setDeleteAlert([<DeleteSuccessAlert onConfirm={() => setDeleteAlert([])} />]);
            loadData();
        };
        const failure = () => setDeleteAlert([<DeleteFailedAlert onConfirm={() => setDeleteAlert([])} />]);
        const events = {
            onConfirm: () => api.delete(`/${apiurl}/${item.rateId}`).then(success).catch(failure),
            onCancel: () => setDeleteAlert([])
        }
        setDeleteAlert([<ConfirmDeleteAlert {...events} />])
    }, [loadData]);

    React.useEffect(() => {
        if (canAutoOpen && data && data.length === 1 && params.requestId && params.action && params.action === "joborder") {
            setItemInEdit(data[0]);
        }
    }, [canAutoOpen, data, params]);
    
    useEffect(() => {
        if (!pnMessage) {
            setParagraphNotification([]);
            return;
        }

        var events = {
            onConfirm: () => {
                setPnMessage(null);
                setPnTitle(null);
            },
            message: pnMessage,
            title: pnTitle ?? pnTitleOnGenerate
        }
        setParagraphNotification([<ParagraphNotification {...events} />]);
    }, [pnMessage, pnTitle]);
    
    useEffect(() => {
        setTopLeftBar(topLeftBarForThis);

        const apiCalls = [
            api.get('lookup/component'),
            api.get('lookup/employmentcategory')
        ];

        Promise.all(apiCalls)
            .then((response) => {
                setLookups({
                    components: [...response[0].data],
                    employmentcategories: [...response[1].data]
                })
            })
            .catch(error => console.error(error))
            //.finally(() => setLoading(false));
        ;
    }, []);

    useEffect(() => {
        loadData();
        setTopLeftBar(topLeftBarForThis);
    }, [selectedProject])

    const topLeftBarForThis = (
        <>
        {
            isReadonly ?
            null
            :
            <TooltipButton
                id="addnew"
                title="Add New"
                className="btn-icon mr-2 mb-2"
                color="default"
                size="sm"
                type="button"
                disabled={!selectedProject}
                onClick={() => {
                    setItemInEdit({
                        rateId: 0,
                        projectId: selectedProject.projectId,
                        startDate: new Date()
                    });
                    setDrawerMode(Mode.ADD);
                }}
            >
                <i className="fas fa-plus pt-1"></i>
            </TooltipButton>
        }
            <TooltipButton
                id="export"
                title="Export to Excel"
                className="btn-icon mr-2 mb-2"
                color="default"
                size="sm"
                type="button"
                disabled={!selectedProject}
                onClick={() => {
                    setLoading(true);
                    var data = {
                        projectId: projectid
                    };
                    let url = `${apiurl}/export/${selectedProject.projectId}`;
                    api.get(url, { responseType: 'blob' })
                        .then(blob => {
                            fileDownload(blob.data, "rates.xlsx");
                        }).catch(error => {
                            console.error(error)
                        }).finally(() => setLoading(false))
                }}
            >
                <i className="fas fa-file-excel"></i> Export
            </TooltipButton>
        {
            isReadonly ?
            null
            :
            <TooltipButton
                id="import"
                title="Import"
                className="btn-icon mr-2 mb-2"
                color="default"
                size="sm"
                type="button"
                disabled={!selectedProject}
                onClick={() => {
                    //setLoading(true);
                    setImportDialogIsOpen(true);

                }}>
                <i className="fas fa-file-import"></i> Import
            </TooltipButton>
        }
            <h5 className="text-left ml-3 d-inline">Rate Sheet</h5>
        </>
    );

    return (
        <>
            {loading && <Loader />}
            {deleteAlert.length > 0 && deleteAlert}
            {paragraphNotification.length > 0 && paragraphNotification}
            <Container fluid className="px-0">
                <Row noGutters>
                    <Col sm={12}>
                        <div className="ag-theme-alpine ag-grid ag-ignore-disabled-input" style={{ width: '100%', height: '67vh' }}>
                            <AgGridReact
                                ref={gridRef}
                                gridOptions={null}
                                //domLayout={'autoHeight'}
                                columnDefs={columnDefs}
                                rowData={data}
                                defaultColDef={defaultColDef}
                                loadingOverlayComponent={loadingOverlayComponent}
                                //sideBar={sideBar}
                                suppressColumnVirtualisation={false}
                                suppressRowVirtualisation={false}
                                debounceVerticalScrollbar={false}
                                rowBuffer={20}
                                headerHeight={30}
                                groupHeaderHeight={30}
                                rowHeight={30}
                                floatingFiltersHeight={30}
                                // readOnlyEdit={true}
                                // onRowDataUpdated={() => resizeColumns()}
                                suppressDragLeaveHidesColumns={true}
                                suppressColumnMoveAnimation={true}
                                animateRows={false}
                                onCellEditRequest={onCellEditRequest}
                                excelStyles={excelStyles()}
                                pagination={true}
                                paginationPageSize={pageSize}
                                cacheBlockSize={pageSize}
                                //rowModelType={'serverSide'}
                                //serverSideInfiniteScroll={true}
                                //onGridReady={onGridReady}
                                sortingOrder={['asc', 'desc']}
                                groupDisplayType={'multipleColumns'}
                                autoGroupColumnDef={autoGroupColumnDef}
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
            {
                !!itemInEdit &&
                <RatesEditor
                    item={itemInEdit}
                    employmentcategories={[...lookups.employmentcategories]}
                    onClose={() => setItemInEdit(null)}
                    onSaved={() => loadData()}
                    drawerMode={drawerMode}
                />
            }
            {
                importDialogIsOpen && !!selectedProject && !isReadonly &&
                <RateImportDialog
                    projectId={selectedProject.projectId}
                    onClose={() => {
                        setImportDialogIsOpen(false);
                        setLoading(false);
                    }}
                    loadData={loadData}
                />
            }
        </>
    )
}


export const excelStyles = () => {
    const headerDefaultStyle = {
        alignment: {
            vertical: 'Center',
            horizontal: "Center",
        },
        interior: {
            color: '#f8f8f8',
            pattern: 'Solid',
            patternColor: undefined,
        },
        borders: {
            borderTop: {
                color: '#babfc7',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderRight: {
                color: '#babfc7',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderBottom: {
                color: '#babfc7',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderLeft: {
                color: '#babfc7',
                lineStyle: 'Continuous',
                weight: 1,
            },
        },
        font: {
            fontName: 'Roboto',
            color: '#181d1f',
            bold: true,
            size: 12,
        },
    }

    return [
        {
            id: 'header',
            ...headerDefaultStyle
        },
        {
            id: 'date-header',
            ...headerDefaultStyle,
            alignment: {
                vertical: 'Center',
                horizontal: "Center",
                rotate: 90,
            },
        },
        {
            id: 'cell',
            alignment: {
                vertical: 'Top',
                wrapText: true,
            },
            interior: {
                color: '#ffffff',
                pattern: 'Solid',
                patternColor: undefined,
            },
            borders: {
                borderTop: {
                    color: '#babfc7',
                    lineStyle: 'Continuous',
                    weight: 1,
                },
                borderRight: {
                    color: '#babfc7',
                    lineStyle: 'Continuous',
                    weight: 1,
                },
                borderBottom: {
                    color: '#babfc7',
                    lineStyle: 'Continuous',
                    weight: 1,
                },
                borderLeft: {
                    color: '#babfc7',
                    lineStyle: 'Continuous',
                    weight: 1,
                },
            },
            font: {
                fontName: 'Roboto',
                color: '#181d1f',
                weight: 700,
                size: 12,
            },
        },
    ];
};
